export default function DividerLine({
  color,
  className = '',
  smallMarging = false,
  thick = false,
}: {
  color?: string | null;
  className?: string;
  smallMarging?: boolean;
  thick?: boolean;
}) {
  return (
    <hr
      className={`border-t-${color ? color : 'enph-grey-03'} ${
        thick ? 'border-t-2' : ''
      } ${
        smallMarging ? 'my-[12px] md:my-[20px]' : 'my-[40px] md:my-[60px]'
      } ${className}`}
    ></hr>
  );
}
